export const subscriptions = [
  { text: "Standard", value: "standard" },
  { text: "Pro", value: "pro" },
  { text: "Premium", value: "premium" },
];
